<ng-container *ngFor="let option of options">

  <input type="radio"
         id="{{name}}_{{option.key}}"
         [ngModel]="selectedOption"
         (ngModelChange)="changeSelectedOption($event)"
         [disabled]="disabled"
         name="{{name}}"
         value="{{option.key}}">

  <label for="{{name}}_{{option.key}}"
         [translate]="option.titleKey"></label>

</ng-container>
